import React from 'react'
import './Opps.scss'
import opps from '../../assets/images/DashboardImages/images/404 error 1.png'

const Opps = () => {
    return (
        <div>
            <div className='opps-main-container'>
                <h2>Oops!</h2>
                <img src={opps} alt='' />
                <h5>Page not found</h5>
            </div>
        </div>
    )
}

export default Opps